import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { Flex } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: `/spark/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="total_borrow"
            footer={true}
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.symbol,
                    address: data.underlying_address
                  }
                }
              }
            }}
          />
          <KpiCard
            title="Total Supply"
            variant="dai"
            data={data}
            field="total_supply"
            footer={true}
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: {
                    name: data.symbol,
                    address: data.underlying_address
                  }
                }
              }
            }}
          />

          <KpiCard
            title="Debt Collateralization"
            data={data}
            field="collateral_backing"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
        </Flex>
        <HistoricTabs />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="APY"
            data={data}
            field="supply_apy"
            options={{
              percentage: true
            }}
          />
          <KpiCard
            title="Utilization"
            data={data}
            field="utilization_rate"
            options={{
              percentage: true
            }}
          />
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiSkeleton />
      <KpiSkeleton />
    </Flex>
  );
}
